var _path, _circle, _circle2, _circle3, _path2, _path3;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNotification = function SvgNotification(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "03dc9ade-1ad3-45f1-be49-5d4888589659",
    "data-name": "ICON",
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "44bfeb87-ee3c-4b20-914d-005fac323137",
    "data-name": "93ff4d18-3497-45db-b877-d4ab9e8b4a69",
    d: "M33.41,158.59",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 167,
    r: 5,
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 167,
    r: 3.13,
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 167,
    r: 1.25,
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96,36c-16,0-23.19,7.71-24,8.44-5.22,4.71-7.5,10.3-8.44,17.39l-.18,5.81L63,79.24a105,105,0,0,1-10.12,41.23c-.61,1.21-1.1,2.57-1.76,3.74h0c-.42.77-.85,1.63-1.29,2.38a30.22,30.22,0,0,1-4.63,6h0C39.61,138.21,37,141.22,35,148.7l-.81,2.67A3.77,3.77,0,0,0,38,156.09H153.61a3.77,3.77,0,0,0,3.81-4.72l-.81-2.67c-2-7.48-4.65-10.49-10.26-16.13a30.22,30.22,0,0,1-4.63-6c-.44-.75-.87-1.61-1.29-2.38-.66-1.18-1.14-2.53-1.75-3.75a105.16,105.16,0,0,1-10.12-41.22L128.2,67.6,128,61.88c-.93-7.11-1.79-12.72-7-17.44C120.19,43.71,112,36,96,36Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.9,36V32A11.83,11.83,0,0,0,96,20,12,12,0,0,0,84,32v4",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#333",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotification, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notification.9611a9b9.svg";
export { ForwardRef as ReactComponent };